module.exports = __webpack_public_path__ + "img/Arrow_Right.2f950b14.svg";